(() => {
  if (window.__olivineRestockRocketBound) return;
  window.__olivineRestockRocketBound = true;

  const ANCHOR_SELECTOR = '[data-restock-rocket-anchor], .main-product-container-info-restock-anchor, .product-unavailable';
  const FLOAT_SELECTOR = '.restock-rocket-button-container-float-right, .restock-rocket-button-container-float-left';
  const BUTTON_SELECTOR = '.restock-rocket-button-product';
  const FORM_SELECTOR = '[data-pdp-buy-buttons], [data-variant-modal-buy-buttons], .main-product-container-info-buttons';

  const getApi = () => window._RestockRocket || window.RestockRocket || null;

  const getActiveSoldOutForm = (preferredForm) => {
    if (preferredForm?.classList.contains('is-sold-out')) return preferredForm;

    const modalForm = document.querySelector(
      '.product-card-variant-modal[open] [data-variant-modal-buy-buttons].is-sold-out'
    );
    if (modalForm) return modalForm;

    return document.querySelector(`${FORM_SELECTOR}.is-sold-out`);
  };

  const placeNotifyButton = (preferredForm) => {
    const form = getActiveSoldOutForm(preferredForm);
    const anchor = form?.querySelector(ANCHOR_SELECTOR) || document.querySelector(ANCHOR_SELECTOR);
    if (!form || !anchor || !form.classList.contains('is-sold-out')) return false;

    const alreadyInline = form.querySelector(BUTTON_SELECTOR);
    if (alreadyInline) {
      alreadyInline.classList.remove('restock-rocket-button-float');
      form.classList.add('has-restock-rocket');
      return true;
    }

    const floatContainer = document.querySelector(FLOAT_SELECTOR);
    const floatButton =
      floatContainer?.querySelector(BUTTON_SELECTOR) ||
      document.querySelector(`${FLOAT_SELECTOR} ${BUTTON_SELECTOR}`) ||
      document.querySelector(BUTTON_SELECTOR);

    if (!floatButton) return false;

    floatButton.classList.remove('restock-rocket-button-float');
    anchor.insertAdjacentElement('afterend', floatButton);
    floatContainer?.remove();
    form.classList.add('has-restock-rocket');
    return true;
  };

  const renderNotifyForVariant = (variantId, form) => {
    if (!variantId) return false;

    const api = getApi();
    const id = String(variantId);
    let targetSelector = ANCHOR_SELECTOR;

    if (form?.hasAttribute('data-variant-modal-buy-buttons')) {
      targetSelector = '[data-variant-modal-buy-buttons] [data-restock-rocket-anchor]';
    } else if (form?.hasAttribute('data-pdp-buy-buttons')) {
      targetSelector = '[data-pdp-buy-buttons] [data-restock-rocket-anchor]';
    }

    try {
      if (typeof api?.renderButtonForVariant === 'function') {
        api.renderButtonForVariant(id, targetSelector);
        return true;
      }
    } catch (error) {
      console.warn('Restock Rocket renderButtonForVariant failed.', error);
    }

    return false;
  };

  const requestNotifyButton = (variant, preferredForm) => {
    const form = preferredForm || getActiveSoldOutForm();
    if (!form || !variant || variant.available) return;

    form.classList.add('is-sold-out');
    renderNotifyForVariant(variant.id, form);
    placeNotifyButton(form);

    [100, 300, 800, 1600, 3000].forEach((ms) => {
      setTimeout(() => {
        if (!form.isConnected || !form.classList.contains('is-sold-out')) return;
        renderNotifyForVariant(variant.id, form);
        placeNotifyButton(form);
      }, ms);
    });
  };

  const syncSoldOutState = (variant, preferredForm) => {
    const form =
      preferredForm ||
      document.querySelector('.product-card-variant-modal[open] [data-variant-modal-buy-buttons]') ||
      document.querySelector('[data-pdp-buy-buttons], .main-product-container-info-buttons');

    if (!form) return;

    const isSoldOut = Boolean(variant) && variant.available === false;
    form.classList.toggle('is-sold-out', isSoldOut);

    if (!isSoldOut) {
      form.classList.remove('has-restock-rocket');
      return;
    }

    requestNotifyButton(variant, form);
  };

  window.OlivineRestockRocket = {
    syncSoldOutState,
    requestNotifyButton,
    placeNotifyButton,
  };

  const boot = () => {
    const form = document.querySelector('[data-pdp-buy-buttons].is-sold-out, .main-product-container-info-buttons.is-sold-out');
    if (!form) return;

    const atc = document.querySelector('add-to-cart[type="normal"]');
    const variantId = atc?.getAttribute('variant-id');
    const variant = variantId
      ? { id: variantId, available: false }
      : { id: form.querySelector('input[name="id"]')?.value, available: false };

    requestNotifyButton(variant, form);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('variant:changed', (event) => {
    // Solo sincroniza el formulario PDP; el modal llama syncSoldOutState directo.
    const pdpForm = document.querySelector('[data-pdp-buy-buttons], add-to-cart[type="normal"] .main-product-container-info-buttons');
    if (!pdpForm) return;
    syncSoldOutState(event.detail?.variant, pdpForm);
  });

  window.addEventListener('stoq:loaded', () => {
    const form = getActiveSoldOutForm();
    if (!form) return;

    const variantId =
      form.closest('add-to-cart')?.getAttribute('variant-id') ||
      form.querySelector('input[name="id"]')?.value;

    if (variantId) {
      requestNotifyButton({ id: variantId, available: false }, form);
    }
  });

  const observer = new MutationObserver(() => {
    const form = getActiveSoldOutForm();
    if (form) placeNotifyButton(form);
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
